export default "__VITE_ASSET__9a5824bf__"